// CookieBanner.js
import React, { useState, useEffect } from 'react';
import { useCookies } from 'react-cookie';
import {
  BannerContainer,
  BannerMessage,
  ButtonContainer,
  AcceptButton,
  DeclineButton,
  Overlay,
} from './CookieBannerStyles';

const generateRandomValue = () => {
  return Math.random().toString(36).substring(2) + Date.now();
};

const CookieBanner = () => {
  const [cookies, setCookie] = useCookies();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const necessarySet = Object.keys(cookies).some(key => key.startsWith('ck_ne_'));
    const marketingSet = Object.keys(cookies).some(key => key.startsWith('ck_ma_'));
    const functionalSet = Object.keys(cookies).some(key => key.startsWith('ck_fu_'));
    
    if (!necessarySet && !marketingSet && !functionalSet) {
      setIsVisible(true);
    }
  }, [cookies]);

  const setConsentCookie = (category) => {
    const name = `ck_${category}_${generateRandomValue()}`;
    const value = generateRandomValue();
    setCookie(name, value, {
      path: '/',
      maxAge: 31536000,
      secure: true, // Nur über HTTPS
    });
  };

  const handleAcceptAll = () => {
    setConsentCookie('ne');
    setConsentCookie('fu');
    setConsentCookie('ma');
    setIsVisible(false);

    // Beispiel: Externe Skripte bei Zustimmung laden
    loadExternalScripts();
  };

  const handleAcceptNecessary = () => {
    setConsentCookie('ne');
    setIsVisible(false);
  };

  const loadExternalScripts = () => {
    const script = document.createElement('script');
    script.src = "https://www.googletagmanager.com/gtag/js?id=G-XXXXXXX"; // deine ID hier
    script.async = true;
    document.head.appendChild(script);

    script.onload = () => {
      window.dataLayer = window.dataLayer || [];
      function gtag() { window.dataLayer.push(arguments); }
      gtag('js', new Date());
      gtag('config', 'G-XXXXXXX'); // auch hier deine ID
    };
  };

  if (!isVisible) return null;

  return (
    <Overlay>
      <BannerContainer>
        <BannerMessage>
          Um Ihnen ein optimales Nutzungserlebnis zu bieten und unsere Website kontinuierlich zu verbessern, verwenden wir Cookies. Dabei arbeiten wir mit ausgewählten Partnern zusammen, um Ihnen personalisierte Inhalte und Werbung bereitzustellen. Weitere Informationen sowie Einstellungsmöglichkeiten finden Sie in unseren Datenschutzhinweisen.
        </BannerMessage>
        <ButtonContainer>
          <DeclineButton onClick={handleAcceptNecessary}>Nur notwendige akzeptieren</DeclineButton>
          <AcceptButton onClick={handleAcceptAll}>Alle Cookies akzeptieren</AcceptButton>
        </ButtonContainer>
      </BannerContainer>
    </Overlay>
  );
};

export default CookieBanner;